import React, { Component } from "react";
import Slider from "react-slick";
import Profile from '../assets/image/tasti-image.png';
import IconLeft from '../assets/image/quote-2.png';
import IconRight from '../assets/image/Icons1.png';
import LeftArrow from '../assets/image/Icons1.png';
import RightArrow from '../assets/image/Icons1.png';

const Testimonial = () => {

    const SilderRemond = [
        {
            profileImage: Profile,
            title:'Reymond Galario',
            country:'Sydney, Australia',
            disc:"Lorem Ipsum is simply dummy text of the printing and typeSettings industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries but also the leap into electronic typeSettings",
        },
        {
            profileImage: Profile,
            title:'Reymond Galario',
            country:'Sydney, Australia',
            disc:"Lorem Ipsum is simply dummy text of the printing and typeSettings industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries but also the leap into electronic typeSettings ",
        },
        {
            profileImage: Profile,
            title:'Reymond Galario',
            country:'Sydney, Australia',
            disc:"Lorem Ipsum is simply dummy text of the printing and typeSettings industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries but also the leap into electronic typeSettings",
        }
    ]

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
      };


  return (
    <div className="tasti">
      <div className="container">
          <div className="sec-head">
              <h3 className="roco-font mb-3">WHAT OUR CLIENT SAYS</h3>
              <p className="mb-5">Lorem Ipsum is simply dummy text of the printing and typese ttingindus orem<br/> Ipsum has beenthe standard dummy.</p>
          </div>
          <div className="tasti-slide">
            <Slider {...settings}>
                {SilderRemond.map(({title, profileImage, disc,country },index)=>{    
                    return (<div key={index} className="reymond">
                        <img src={profileImage}/>
                        <h2 className="mb-2 mt-4">{title}</h2>
                        <p>{country}</p>
                        <div className="text" style={{position:'relative'}}>
                            <img className="left" src={IconLeft}/>
                            <p>{disc}</p>
                            <img className="right" src={IconRight}/>
                        </div>
                    </div>)
                })}
            </Slider>
          </div>
      </div>
  </div>
  )
}

export default Testimonial
